<script lang="ts">
  import LoginForm from "./LoginForm.svelte";
  import SignupForm from "./SignupForm.svelte";
  import ForgotPasswordForm from "./ForgotPasswordForm.svelte";
  import ResetPasswordForm from "./ResetPasswordForm.svelte";
  import ResendConfirmationForm from "./ResendConfirmationForm.svelte";
  import InvitationForm from "./InvitationForm.svelte";

  interface Props {
    pageType: string;
    inviteToken?: string;
    partnerToken?: string;
    attributionToken?: string;
    csrfToken?: string;
    resetToken?: string;
    inviteAccountName?: string;
    inviteByName?: string;
    inviteEmail?: string;
    returnTo?: string;
  }

  let {
    pageType = "login",
    inviteToken = "",
    partnerToken = "",
    attributionToken = "",
    csrfToken = "",
    resetToken = "",
    inviteAccountName = "",
    inviteByName = "",
    inviteEmail = "",
    returnTo = "",
  }: Props = $props();

  const isSignupPage = $derived(pageType === "signup");
</script>

<div class={`min-h-screen flex justify-center bg-background text-foreground px-4 text-base sm:px-6 lg:px-8 ${isSignupPage ? "items-start py-8 lg:py-12" : "items-center py-10"}`}>
  <div class={`w-full space-y-8 ${isSignupPage ? "max-w-7xl" : "max-w-lg"}`}>
    <div class="flex flex-col items-center gap-2">
      <img src="/DT-logo.jpg" alt="DataTurk.ai" class="size-12 rounded-lg object-contain" />
      <span class="font-semibold text-xl tracking-wide" style="font-family: 'Sora', sans-serif;">DataTurk.ai</span>
    </div>

    {#if pageType === "login"}
      <LoginForm {csrfToken} {inviteToken} {returnTo} />
    {:else if pageType === "signup"}
      <SignupForm
        {inviteToken}
        {partnerToken}
        {attributionToken}
        {csrfToken}
        {inviteAccountName}
        {inviteByName}
        {inviteEmail}
      />
    {:else if pageType === "forgot-password"}
      <ForgotPasswordForm {csrfToken} />
    {:else if pageType === "reset-password"}
      <ResetPasswordForm {csrfToken} {resetToken} />
    {:else if pageType === "resend-confirmation"}
      <ResendConfirmationForm {csrfToken} />
    {:else if pageType === "invitation"}
      <InvitationForm
        {csrfToken}
        {inviteToken}
        {inviteAccountName}
        {inviteByName}
      />
    {/if}
  </div>
</div>

